import {
  Component,
  EventEmitter,
  inject,
  Output,
  ViewChild,
} from '@angular/core';
import { PickList, PickListModule } from 'primeng/picklist';
import { IndicatorStore } from '../../../stores/indicator/indicator.state';
import { Indicator } from '../../../models/indicator';
import { BadgeModule } from 'primeng/badge';
import { DividerModule } from 'primeng/divider';
import { IndicatorFilterComponent } from '../indicator-filter/indicator-filter.component';
import { NgIf } from '@angular/common';
import { SharedModule } from 'primeng/api';
import { TagListComponent } from '../tag-list/tag-list.component';
import { TagModule } from 'primeng/tag';
import { CategoryStore } from '../../../stores/category/category.state';
import { units } from '../../../models/unit';
import { ListboxModule } from 'primeng/listbox';
import { FormsModule } from '@angular/forms';

@Component({
  selector: 'app-indicator-set-pick-list',
  standalone: true,
  imports: [
    BadgeModule,
    DividerModule,
    IndicatorFilterComponent,
    NgIf,
    PickListModule,
    SharedModule,
    TagListComponent,
    TagModule,
    ListboxModule,
    FormsModule,
  ],
  templateUrl: './indicator-set-pick-list.component.html',
  styleUrl: './indicator-set-pick-list.component.scss',
})
export class IndicatorSetPickListComponent {
  @ViewChild('listPickerCtrl') listPickerCtrl!: PickList;
  @Output() indicatorSelection: EventEmitter<Indicator> =
    new EventEmitter<Indicator>();

  readonly indicatorStore = inject(IndicatorStore);
  readonly categoryStore = inject(CategoryStore);

  selected: Indicator[] = [];
  selectedSet?: Indicator;

  protected readonly units = units;

  /**
   * Emits the currently selected set using the `indicatorSelection` event if a set is selected.
   *
   * @return {void} Does not return a value.
   */
  selectSet(): void {
    if (this.selectedSet) this.indicatorSelection.emit(this.selectedSet);
  }
}
